import React, { useRef } from 'react';
import Downshift from 'downshift';
import 'styled-components/macro';
import { withRouter } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
import {
  SLink,
  Menu,
  MenuWrapper,
  Input,
  Item,
  SearchIconWrapper,
  Root,
} from './styles';
import constantes from '../../resources/constantes.json';
import { getItems } from './utils';
import { getUrl } from '../../utils';
import SearchIcon from '../svg/Search';
import { useTranslate } from '../../contexts/languageContext';
/**
 * Buscador con autocompletado accesible, partiendo de la libreria downshift. Sirve
 * para buscar entre todos los ámbitos de una elección.
 * Utilizamos react-highlight-words para remarcar las letras del nombre de los ámbitos
 * que coinciden con la búsqueda del usuario.
 *
 */

const Buscador = withRouter(
  ({
    className,
    eleccion,
    nomenclator,
    page,
    history,
    onSelect,
    searchIconColor,
    parentLevel,
  }) => {
    const t = useTranslate();
    const items = nomenclator.ambitos[eleccion];
    const inputRef = useRef();
    const getA11yStatusMessage = ({ resultCount }) => {
      resultCount > 0
        ? t('a11yBuscadorResultados').replace('XX', resultCount)
        : t('sinResultados');
    };

    return (
      <div className={className}>
        <Downshift
          itemToString={itemToString}
          onSelect={onSelect}
          //defaultIsOpen
          onChange={(item, { clearSelection }) => {
            //se llama cuando cambia la opción seleccionada (también cuando hacemos clearSelection)
            if (item) {
              history.push(
                getUrl({ id: item.i, eleccion, nomenclator, page, parentLevel })
              );
              inputRef &&
                inputRef.current &&
                inputRef.current.blur &&
                inputRef.current.blur();
            }
            clearSelection();
          }}
          getA11yStatusMessage={getA11yStatusMessage}
        >
          {({
            getInputProps,
            getMenuProps,
            getItemProps,
            getRootProps,
            isOpen,
            selectedItem,
            inputValue,
            highlightedIndex,
          }) => {
            const filteredItems = getItems(items, inputValue);
            return (
              <Root
                {...getRootProps({
                  'aria-label': t('buscadorPlaceholder'),
                })}
                aria-labelledby={undefined}
              >
                <div
                  css={`
                    height: 100%;
                  `}
                >
                  <Input
                    {...getInputProps({
                      isOpen,
                      placeholder: t('buscadorPlaceholder'),
                      ref: inputRef,
                      autoCapitalize: 'off',
                      spellCheck: 'false',
                      autoCorrect: 'off',
                      'aria-label': t('buscadorPlaceholder'),
                    })}
                    aria-labelledby={undefined}
                  />
                  <SearchIconWrapper>
                    <SearchIcon fill={searchIconColor} />
                  </SearchIconWrapper>
                </div>
                {isOpen && filteredItems.length < 150 ? (
                  <MenuWrapper isOpen={isOpen}>
                    <Menu
                      {...getMenuProps({
                        isOpen,
                      })}
                    >
                      {filteredItems.length !== 0 ? (
                        filteredItems.map((item, index) => (
                          <Item
                            {...getItemProps({
                              item,
                              index: index,
                              isActive: highlightedIndex === index,
                              isSelected: selectedItem === item,
                              key: item.i,
                            })}
                          >
                            <SLink
                              tabIndex={-1}
                              to={getUrl({
                                id: item.i,
                                eleccion,
                                nomenclator,
                                page,
                                parentLevel,
                              })}
                            >
                              <Highlighter
                                highlightClassName="search-highlight"
                                searchWords={inputValue.split(' ')}
                                autoEscape={true}
                                textToHighlight={itemToString(item)}
                              />
                              {additionalText(item, eleccion, nomenclator)}
                            </SLink>
                          </Item>
                        ))
                      ) : (
                        <Item cursor="default">{t('sinResultados')}</Item>
                      )}
                    </Menu>
                  </MenuWrapper>
                ) : null}
              </Root>
            );
          }}
        </Downshift>
      </div>
    );
  }
);

const additionalText = (item, eleccion, nomenclator) => {
  const dep = eleccion === constantes.eleccion.citrep ? ' (CITREP)' : '(DEPARTAMENTO)';
  //TODO: ver como es exacatamente lo de que haya varios padres y tener eso en cuenta aquí.
  switch (item.l) {
    case constantes.level.colombia:
      return '';
    case constantes.level.departamento:
      //TODO: quizás aquí solo queremos poner (DEPARTAMENTO) en los casos en los que
      //el nombre del municipio sea igual al del departamento

      //bogotá no es un departamento
      return item.n.toLowerCase().includes('bogot') ? '' : dep;
    default:
      return `, ${nomenclator.ambitos[eleccion][item.p[0]].n}`;
  }
};

const itemToString = i => (i && i.n ? i.n : '');

export default Buscador;
